import { motion } from "framer-motion";
import { Phone, ArrowUpRight, ArrowRight } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY } from "@/lib/site";

const VARIANTS = {
  coral: "bg-coral text-white hover:bg-coral-dark shadow-[0_10px_30px_-10px_rgba(255,111,79,0.8)]",
  navy: "bg-ink text-white hover:bg-[#143a61]",
  soft: "bg-brand-soft text-brand hover:bg-brand hover:text-white",
  white: "bg-white text-ink hover:bg-brand-soft",
};

export const CallButton = ({ testId, label = "Call now", variant = "coral", size = "md", showNumber = false, className = "" }) => {
  const sz = size === "lg" ? "px-7 py-4 text-sm" : size === "sm" ? "px-3.5 py-2 text-xs" : "px-5 py-3 text-sm";
  return (
    <motion.a href={PHONE_TEL} data-testid={testId} whileHover={{ y: -2 }} whileTap={{ scale: 0.97 }}
      className={`group inline-flex items-center justify-center gap-2.5 rounded-xl font-display font-bold uppercase tracking-wide transition-colors duration-300 ${VARIANTS[variant]} ${sz} ${className}`}>
      <Phone className="h-4 w-4 transition-transform duration-300 group-hover:rotate-12" />
      <span>{showNumber ? PHONE_DISPLAY : label}</span>
      {size !== "sm" && <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />}
    </motion.a>
  );
};

export const TextLink = ({ href = PHONE_TEL, children, testId, className = "" }) => (
  <a href={href} data-testid={testId} className={`group inline-flex items-center gap-1.5 text-sm font-bold text-brand ${className}`}>
    {children}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </a>
);
